import {
  invertStrokeColor
} from "./chunk-VI6WTKMV.js";

// src/icons/CircleCheck.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function CircleCheck({
  strokeWidth = "1.14286",
  strokeLinecap = "butt",
  strokeLinejoin = "miter"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "8", cy: "8", r: "8", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.57153 7.98591L6.65379 10.0682C6.65379 10.0682 9.08556 7.6364 11.0076 5.71436",
            className: invertStrokeColor,
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  CircleCheck
};
